import { createSelector } from 'reselect';

import getApplicationIdSelector from '/business/shared/state/selectors/application/getApplicationIdSelector';
import type { UnitData } from '/business/shared/state/selectors/types';
import getUnitSelector from './getUnitSelector';

export default createSelector(
  getUnitSelector,
  getApplicationIdSelector,
  (unitData: UnitData | false = false, appId = null) => {
    if (!unitData || appId !== unitData.fetchedForApplicationId) {
      return false;
    }
    return unitData.fetched === true;
  },
);
